<script>

export const homePageNewsClipRow = {
    // outerContainerStyle,
    // innerContainerStyle,
    outerContainerClasses: "fbicc-homepage-news-item-container",
    publishClasses: "fbicc-homepage-newsclip-publish",
    linkClasses: "fbicc-homepage-newsclip-link",
    imageContainerClasses: "fbicc-homepage-newsclip-image-container",
    htmlClasses: "fbicc-homepage-newsclip-html"
}

export default { "name": "theme-news" }

</script>

<style>

.fbicc-homepage-news-item-container {
  margin-bottom:40px !important;
}

.fbicc-homepage-newsclip-publish {

}
.fbicc-homepage-newsclip-link {

}
.fbicc-homepage-newsclip-image-container {
  width:200px !important;
}
.fbicc-homepage-newsclip-html {

}

</style>

